@file:OptIn(ExperimentalTime::class)

package com.macrofocus.eflux

import korlibs.time.DateTime
import org.molap.datetime.DateTimeTz
import kotlin.js.Date
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

fun String.toRawDate(): Date {
    val year = substring(0, 4).toInt()
    val month = substring(4, 6).toInt()
    val day = substring(6, 8).toInt()
    val hour = substring(9, 11).toInt()
    val min = substring(11, 13).toInt()
    return Date(year, month - 1, day, hour, min, 0, 0)
}

fun Date.toRawString() : String {
    return getFullYear().toString().padStart(4, '0') +
            (getMonth() + 1).toString().padStart(2, '0') +
            getDate().toString().padStart(2, '0') +
            "_" +
            getHours().toString().padStart(2, '0') +
            getMinutes().toString().padStart(2, '0')
}

fun DateTime.toJsDate() : Date {
    return Date(this.yearInt, this.month0, this.dayOfMonth, this.hours, this.minutes, this.seconds)
}

fun Date.toDateTime() : DateTime {
    return DateTime(this.getFullYear(), this.getMonth() + 1, this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds())
}

@Deprecated("Doesn't work properly", ReplaceWith(".toRawString().toDateTimeTz()"))
fun DateTime.toDateTimeTz() : DateTimeTz {
    return DateTimeTz(Instant.fromEpochMilliseconds(unixMillisDouble.toLong()), kotlinx.datetime.TimeZone.UTC)
}